import { queryClient } from '@/utils/query/queryClient';
import { librarySectionsQueryOptions } from '@/hooks/queries/useLibrarySectionsQuery';

/**
 * Warms the `['library-sections']` cache — the same query `PresetFeedScreen`
 * reads through `usePresetFeedData` (and the library screen through
 * `useLibrarySectionsQuery`) — so the data is in flight before either screen
 * mounts.
 *
 * Called from the entry's `setup()` immediately after `setupContext`: the
 * request headers come from `getContext()`, and firing any earlier (e.g. at
 * module evaluation) would make `fetchLibraryData` swallow the
 * missing-context error and cache `null` as fresh data (empty library for
 * the whole `staleTime`). Safe to call more than once — React Query dedupes
 * in-flight fetches and respects `staleTime`.
 */
const prefetchPresetFeedData = (): void => {
  queryClient.prefetchQuery(librarySectionsQueryOptions).catch(() => {
    // prefetch failures are non-fatal — the consuming screen refetches
  });
};

export default prefetchPresetFeedData;
